/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: switch-Widget - Einfacher on/off-Schalter
 *
 * Das checkbox-Widget bietet die Möglichkeit Checkbox darzustellen.
 * Die Checkbox kann nur die Werte 0/1 darstellen (aus- bzw. eingeschaltet)
 *
 "fields": [
    {
        "id": "lights",
        "length": 1,
        "label": "Lights",
        "unitLabel": "",
        "description": "Switch lights on/off",
        "placeholder": "",
        "widget": "switch",
        "maxItems": 0,
        "visibleItems": 0,
        "group": null,
        "value": 0
        "enums": []
        "validation": null,
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im checkbox-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes bzw. Anzahl Zeichen (hier ohne Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier ohne Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "checkbox" belegt
 * maxItems      - Maximale Anzahl an auswählbaren Werten/Zeichen (hier ohne Bedeutung)
 * visibleItems  - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktueller Wert (0=off, 1=on)
 * enums         - Alle Auswahlmöglichkeiten (hier ohne Bedeutung)
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * validationState   - Zustand der Validierung (hier ohne Bedeutung)
 * validationMessage - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field - field-Object
 * value  - aktueller Wert
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 *
 */
import React from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'

const Checkbox = ({ field, value, onChange }) => {

    //console.log("Checkbox() field:", field);

    let iconPath = (value) ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />;

    let className = (value) ? "text-webasto-blue" : "text-gray-700";

    return (
        <div onClick={(e) => onChange(e, !value)}
            className="bg-gray-200 inline-block rounded relative h-12 w-full">
            <div className={"pointer-events-none absolute inset-y-0 right-0 flex items-center " + className}>
                <svg className="fill-current h-12 w-12" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16">{iconPath}</svg>
            </div>
        </div>
    )

};

export default Checkbox